import { resolve } from "inversify-react";
import * as React from "react";
import { connect } from "react-redux";
import Container from "src/core/ui/container";
import Tabs from "src/core/ui/tabs";
import AdminService from "src/services/admin.service";
import ArtworksTable from "./tables/artworks-table";
import ExpensesTable from "./tables/expenses-table";
import UsersTable from "./tables/users-table";
import { ArtworkInformation, ExpenseInformation, IApplicationState, UserInformation } from "../../typings";

interface IAdminPanelProps {
    users: UserInformation[];
    expenses: ExpenseInformation[];
    artworks: ArtworkInformation[];
}

interface IAdminPanelState {}

class AdminPanel extends React.Component<IAdminPanelProps, IAdminPanelState> {
    @resolve(AdminService)
    public admin: AdminService;

    public async componentDidMount(): Promise<void> {
        await this.admin.listUsers();
        await this.admin.listExpenses();
        await this.admin.listArtworks();
    }

    render(): JSX.Element {
        const { users, expenses, artworks } = this.props;

        return (
            <Container className="no-padding admin-panel">
                <Tabs
                    titles={["USERS", "ARTWORKS", "EXPENSES"]}
                    bodies={[<UsersTable users={users} />, <ArtworksTable artworks={artworks} />, <ExpensesTable expenses={expenses} />]}
                    selectedIndex={0}
                />
            </Container>
        );
    }
}

function mapStateToProps(state: IApplicationState, ownProps: IAdminPanelProps): IAdminPanelProps {
    return {
        ...ownProps,
        users: state.admin.users ? state.admin.users : [],
        expenses: state.admin.expenses ? state.admin.expenses : [],
        artworks: state.admin.artworks ? state.admin.artworks : [],
    };
}
export default connect(mapStateToProps)(AdminPanel);



// WEBPACK FOOTER //
// ./src/components/admin_panel/admin-panel.tsx